import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import "./_style.scss";
import TkPropertyMessageGet from "../../../utils/TkPropertyMessageGet";
import TkAmountInput from "../../../components/molecules/TkAmountInput";

/**
 * 被共済職員期間
 * @param {any} props.year 被共済職員期間（年）１
 * @param {any} props.month 被共済職員期間（月）１
 * @param {any} props.onChange Changeイベント
 * @return MaePeriod
 */
export const MaePeriod = (props: any) => {
  const { year, month, onChange, disabled } = props;
  const [yearNew, setYearNew] = useState(year);
  const [monthNew, setMonthNew] = useState(month);
  const [yearError, setYearError] = useState("");
  const [monthError, setMonthError] = useState("");

  useEffect(() => {
    onChange && onChange({ year: yearNew, month: monthNew, error: false });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [year, month]);

  useEffect(() => {
    let nowError = false;
    if (yearNew?.target?.value > 99) {
      nowError = true;
      setYearError(TkPropertyMessageGet("TKMSG_SCR0048E", "99"));
    }
    if (monthNew?.target?.value > 11) {
      nowError = true;
      setMonthError(TkPropertyMessageGet("TKMSG_SCR0048E", "11"));
    }

    onChange &&
      onChange({
        year: yearNew?.target ? yearNew.target?.value : yearNew,
        month: monthNew?.target ? monthNew.target?.value : monthNew,
        error: nowError,
      });
    if (nowError) return;
    setYearError("");
    setMonthError("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [yearNew, monthNew]);

  return (
    <Box className="SCRW060102Components">
      <Box className="maePeriod">
        <TkAmountInput
          innerText="年"
          onlyNumber
          inputProps={{ maxLength: 2 }}
          error={!!yearError}
          errorMessage={yearError}
          wantToSetValue={year}
          onGetInputValue={setYearNew}
          disabled={disabled}
        />
        <TkAmountInput
          innerText="月"
          onlyNumber
          inputProps={{ maxLength: 2 }}
          error={!!monthError}
          errorMessage={monthError}
          wantToSetValue={month}
          onGetInputValue={setMonthNew}
          disabled={disabled}
        />
      </Box>
    </Box>
  );
};
